import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Container, { underscoreStyles } from 'components/Container'

import media from 'media'
import theme from 'theme'

export const MAX_WIDTH = 610

const getMaxWidth = (maxWidth) => {
  if (maxWidth === 'full') return '100%'
  else if (maxWidth) return maxWidth
  else return null
}

const margin = '25px'
const doubleMargin = '50px'

const getAttrs = ({ maxWidth, px, pb }) => ({
  maxWidth: getMaxWidth(maxWidth) || MAX_WIDTH,
  pb: pb || 0,
  px,
  renderAs: 'article',
})

// TODO: article SHOULD contain title! and is differnent from content!
const ArticleContainer = styled(Container)
  .attrs(getAttrs)
  .withConfig({
    shouldForwardProp: (prop) => ['underscore'].indexOf(prop) === -1,
  })`
   img {
    display: block;
    max-width: 100%;
    margin: 30px auto;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15) !important;

    &.noImgBoxShadow {
      box-shadow: none !important;
    }
  }

  h1 {
    font-size: 24px;
    font-weight: 600;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin: ${doubleMargin} 0 ${margin} 0;
  }

  h3 {
    margin: ${doubleMargin} 0 ${margin} 0;
  }

  h4,
  h5,
  h6 {
    font-size: 18px;
    font-weight: 600;
    margin: ${margin} 0;
  }

  p {
    line-height: 1.8;
    margin: ${margin} 0;
  }

  li > p {
    margin: 0;
  }

  .video {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15) !important;
  }

  .video iframe,
  .video object,
  .video embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .asterisk {
    font-size: ${theme.fontSizes[30]}px;
    font-style: italic;
  }

  iframe.centered {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  .iframe-mobile {
    width: 100%;

    ${media.tablet`
      width: 450px;
    `}

    ${media.desktop`
      display: none;
    `}
  }

  .iframe-desktop {
    display: none;

    ${media.desktop`
      display: block;
    `}
  }

  a {
    word-break: break-word;
  }

  .gatsby-highlight {
    margin: 20px 0;
    pre > code {
      font-size: 14px;
    }
  }

  table {
    width: 100%;
    max-width: 100%;

    th,
    td {
      text-align: center;
      border: 1px solid black;
      padding: 2px 4px;
    }
  }

  code.language-text {
    word-break: break-all;
  }

  section[type="logo-bar"] + :not(h2) {
    margin-top: 50px;
  }

  ${media.desktop`
    code.language-text {
      word-break: normal;
    }
  `}

  ${({ underscore }) => underscore && underscoreStyles}
`

const Article = ({ children, ...others }) => (
  <ArticleContainer {...others}>{children}</ArticleContainer>
)

Article.propTypes = {
  children: PropTypes.node,
}

export default Article
